import { styled, css } from '@vebox/etui-system';
import { mediaMax, mediaMin } from './utilities/responsive.js';
import { createElement } from 'react';
import { b as _extends } from './_rollupPluginBabelHelpers-3b7bd988.js';
import ReactModal from 'react-modal';

function reactModalAdapter(props) {
  const contentClassName = `${props.className}__content`;
  const overlayClassName = `${props.className}__overlay`;
  ReactModal.setAppElement(props.appElement);
  return /*#__PURE__*/createElement(ReactModal, _extends({}, props, {
    portalClassName: props.className,
    className: contentClassName,
    overlayClassName: overlayClassName,
    ariaHideApp: false,
    closeTimeoutMS: props.animationTiming,
    parentSelector: props.parentSelector
  }));
}
const Modal = styled(reactModalAdapter)`
  &__overlay {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.65);
    z-index: ${({
  theme
}) => theme.zIndex.modal};
  }

  &__content {
    flex: 0 1 auto;
    display: flex;
    outline: none;
    position: relative;
    flex-direction: column;
    background: #fff;
    max-width: 500px;
    opacity: 0;
    border-radius: ${({
  theme
}) => theme.shape.borderRadius}px;
    box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2),
      0px 24px 38px 3px rgba(0, 0, 0, 0.14),
      0px 9px 46px 8px rgba(0, 0, 0, 0.12);

    ${({
  theme
}) => mediaMax(theme).xs`
      width: 100%;
      height: 100%;
      overflow: hidden;
    `};

    ${({
  theme
}) => mediaMin(theme).xs`
       max-height: 90vh;
       min-width: 500px;
       border-radius: 2px;
       margin: 32px;
    `};

    &.ReactModal__Content--after-open {
      opacity: 1;
      transition: opacity ${props => props.animationTiming}ms;
    }
    &.ReactModal__Content--before-close {
      opacity: 0;
    }

    ${props => {
  if (props.fullPageSize) {
    return css`
          width: 100%;
          height: 100%;
          min-width: 100% !important;
          min-height: 100% !important;
          border-radius: 0;
        `;
  }
  return ``;
}};
  }
`;

export { Modal as M };
